var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Companies Directory',"subtitle":'Edit company profile'}}),(_vm.company.id)?_c('company-form',{attrs:{"action":'edit',"company":_vm.company}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }